module.exports = __webpack_public_path__ + "static/media/unassigned-icon.113d5f49.svg";